import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, Form, Input } from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import { editProfile } from '../../store/actions/business';
import './index.css';
function AboutEditModal(props) {
	const [modal, setModal] = useState(false);
	const toggle = () => setModal(!modal);

	const dispatch = useDispatch();
	const { id } = useSelector((state) => state.currentUser.user);

	const [about, setAbout] = useState(props.businessAbout || '');

	const handleSubmit = (e) => {
		e.preventDefault();
		dispatch(editProfile(id, { about }));
		setModal(false);
	};

	const { businessAbout } = props;

	return (
		<div>
			{/* 🔥 Updated Trigger Button */}
			<Button className='cta-pill-btn ml-2' onClick={toggle}>
				<i className='nc-icon nc-settings-gear-65 mr-1' />
				Edit
			</Button>

			<Modal isOpen={modal} toggle={toggle} centered>
				<ModalHeader toggle={toggle}>
					Tell your customers about your business
				</ModalHeader>

				<ModalBody>
					<Form onSubmit={handleSubmit}>
						<Input
							type='textarea'
							id='about'
							name='about'
							rows='4'
							className='mb-3'
							onChange={(e) => setAbout(e.target.value)}
							value={about}
							placeholder={businessAbout}
						/>

						{/* 🔥 Updated Submit Button */}
						<Button className='cta-pill-btn w-100' type='submit'>
							Save Changes
						</Button>
					</Form>
				</ModalBody>
			</Modal>
		</div>
	);
}

export default AboutEditModal;
